import reports from './../../../services/sales/reports.js'

export default {
    namespaced: true,
    state: {
        from: null,
        to: null,
        customer_id: null,
        data: null,
        loading: false
    },
    getters: {
        customer_id: state => state.customer_id,
        from: state => state.from,
        to: state => state.to,
        data: state => state.data,
        loading: state => state.loading
    },
    mutations: {
        customer_id: (state, payload) => state.customer_id = payload,
        from: (state, payload) => state.from = payload,
        to: (state, payload) => state.to = payload,
        data: (state, payload) => state.data = payload,
        loading: (state, payload) => state.loading = payload
    },
    actions: {
        get(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading", true);
                reports.customerStatement({
                    to: context.state.to,
                    from: context.state.from,
                    customer_id: context.state.customer_id
                })
                    .then((response => {
                        context.commit("data", response.data);
                        resolve(response);
                    }))
                    .catch(error => {
                        reject(error)
                    })
                    .finally(() => {
                        context.commit("loading", false);
                    });
            });
        },
        updateParams(context, payload) {
            context.commit("customer_id", payload.customer_id);
            context.commit("from", payload.from);
            context.commit("to", payload.to);
            return new Promise((resolve, reject) => {
                context.dispatch("get").then(response => resolve(response)).catch(error => reject(error));
            })
        }
    }
}